import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as GeneralActions from '../../store/modules/general/actions';
import { useSelector } from 'react-redux';

import {
  generateToken,
  getTriggerAccess,
} from '../../services/trigger/request';
import { shouldBlockLegacyAgent } from './shouldBlockLegacyAgent';

import Animation from '../../components/common/animation';
import { useEffect, useState } from 'react';
import { customUseFlags } from 'src/hooks/customUseFlags';
import { useFlags } from 'flagsmith/react';
import { useHistory } from 'react-router-dom';

function Marketing({ loading }) {
  const history = useHistory();
  const triggerUrl =
    process.env.REACT_APP_DISPARADOR_URL ?? 'https://disparador.digital';

  const [urlIframe, setUrlIframe] = useState('');
  const flag = useFlags(['marketing_list_customers']);
  const canUseMarketing = customUseFlags(flag.marketing_list_customers);
  const currentCustomer = useSelector(
    (state) => state?.chat?.config?.user?.current_customer_id
  );
  const userSuperRole = useSelector((state) => state?.general?.user?.superRole);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      // DEV4-5013: empresa na nova interface não é barrada aqui — o
      // `validateToken` decide e o disparador exibe a mensagem. Empresa no
      // legado mantém o bloqueio de hoje. Falha na consulta assume legado, que é
      // o comportamento atual, então indisponibilidade não libera ninguém.
      let foundation = false;
      try {
        const access = await getTriggerAccess();
        foundation = Boolean(access?.foundation);
      } catch (error) {
        console.error(error);
      }

      if (cancelled) return;

      if (
        shouldBlockLegacyAgent({
          foundation,
          canUseMarketing,
          superRole: userSuperRole,
        })
      ) {
        history.push('/chat');
        return;
      }

      if (!currentCustomer) return;

      try {
        const token = await generateToken();

        if (cancelled) return;

        setUrlIframe(`${triggerUrl}/${currentCustomer}/${token}`);
      } catch (error) {
        console.error(error);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [currentCustomer]);

  if (loading || !urlIframe) {
    return <Animation size="full" />;
  }

  return (
    <iframe src={urlIframe} width="100%" height="100%" title="Disparador" />
  );
}

const mapStateToProps = (state) => ({
  currentUser: state?.general?.user,
  loading: state?.general?.user ? false : true,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(GeneralActions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Marketing);
